<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-filter</v-icon>
                Disposal Summary Report Filter
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-start"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-end"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12" class="d-flex align-end">
                      <v-btn
                        type="submit"
                        color="primary"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        density="compact"
                        height="40"
                        variant="flat"
                        ref="searchButton"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-delete-clock</v-icon>
                Disposal Summary Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                
                <!-- Summary Cards -->
                <v-row class="py-2" v-if="summary.total_records > 0">
                  <v-col cols="12">
                    <v-card class="pa-4 bg-blue-grey-lighten-5">
                      <v-row>
                        <v-col md="2" cols="6">
                          <div class="text-subtitle-2 text-grey-darken-1">Total Disposals</div>
                          <div class="text-h5 font-weight-bold text-primary">{{ summary.total_records }}</div>
                        </v-col>
                        <v-col md="2" cols="6">
                          <div class="text-subtitle-2 text-grey-darken-1">Assets Disposed</div>
                          <div class="text-h5 font-weight-bold text-grey-darken-2">{{ summary.total_assets }}</div>
                        </v-col>
                        <v-col md="3" cols="6">
                          <div class="text-subtitle-2 text-grey-darken-1">Total Book Value</div>
                          <div class="text-h6 font-weight-bold text-info">{{ formatCurrency(summary.total_book_value) }}</div>
                        </v-col>
                        <v-col md="2" cols="6">
                          <div class="text-subtitle-2 text-grey-darken-1">Total Sale Value</div>
                          <div class="text-h6 font-weight-bold text-success">{{ formatCurrency(summary.total_sale_value) }}</div>
                        </v-col>
                        <v-col md="3" cols="12">
                          <div class="text-subtitle-2 text-grey-darken-1">Total Gain/Loss</div>
                          <div class="text-h6 font-weight-bold" :class="summary.total_gain_loss >= 0 ? 'text-success' : 'text-error'">
                            {{ summary.total_gain_loss >= 0 ? '+' : '' }}{{ formatCurrency(summary.total_gain_loss) }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row class="py-2">
                  
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="6" cols="12">
                    <div class="d-flex justify-center">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          :disabled="reports.length === 0"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          :disabled="reports.length === 0"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="reports.length === 0"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12" class="d-flex align-center justify-end">
                    <v-btn
                      v-if="reports.length > 0"
                      variant="outlined"
                      size="small"
                      @click="expandAll"
                      prepend-icon="mdi-arrow-expand-all"
                    >
                      {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </v-btn>
                  </v-col>

                </v-row>

                <!-- Grouped by Disposal Master -->
                <v-expansion-panels v-model="expandedPanels" multiple class="mt-2">
                  <v-expansion-panel
                    v-for="(master, index) in reports"
                    :key="master.id"
                    class="mb-2"
                  >
                    <v-expansion-panel-title class="bg-blue-grey-lighten-5">
                      <v-row no-gutters align="center">
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Disposal Date</div>
                          <div class="font-weight-bold">{{ master.disposal_date }}</div>
                        </v-col>
                        <v-col cols="12" md="2" v-if="master.code">
                          <div class="text-caption text-grey-darken-1">Code</div>
                          <div class="font-weight-medium">{{ master.code }}</div>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Method</div>
                          <v-chip size="small" :color="getDisposalMethodColor(master.disposal_method)">
                            {{ master.disposal_method || 'N/A' }}
                          </v-chip>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Disposal Value</div>
                          <div class="font-weight-bold text-success">{{ formatCurrency(master.total_disposal_value) }}</div>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Assets Count</div>
                          <div class="font-weight-medium">
                            <v-chip size="small" color="primary">{{ master.details.length }}</v-chip>
                          </div>
                        </v-col>
                        <v-col cols="12" md="2" class="text-right">
                          <v-chip size="small" color="success" variant="outlined">
                            <v-icon start size="small">mdi-file-document-outline</v-icon>
                            View Details
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      <!-- Header Info -->
                      <v-row class="mb-2">
                        <v-col cols="12" md="6" v-if="master.approved_by">
                          <v-alert type="success" variant="tonal" density="compact">
                            <strong>Approved By:</strong> {{ master.approved_by }}
                          </v-alert>
                        </v-col>
                        <v-col cols="12" :md="master.approved_by ? '6' : '12'" v-if="master.remarks">
                          <v-alert type="info" variant="tonal" density="compact">
                            <strong>Remarks:</strong> {{ master.remarks }}
                          </v-alert>
                        </v-col>
                      </v-row>

                      <v-data-table
                        :headers="detailHeaders"
                        :items="master.details"
                        :search="search"
                        :hover="true"
                        density="compact"
                        hide-default-footer
                        :items-per-page="-1"
                        class="elevation-1"
                      >
                        <template v-slot:item.index="{ index }">
                          {{ ++index }}
                        </template>

                        <template v-slot:item.book_value="{ item }">
                          <span class="font-weight-medium text-info">{{ formatCurrency(item.book_value) }}</span>
                        </template>

                        <template v-slot:item.sale_value="{ item }">
                          <span class="font-weight-medium text-success">{{ formatCurrency(item.sale_value) }}</span>
                        </template>

                        <template v-slot:item.gain_or_loss="{ item }">
                          <v-chip 
                            size="small" 
                            :color="item.gain_or_loss >= 0 ? 'success' : 'error'"
                            variant="flat"
                          >
                            {{ item.gain_or_loss >= 0 ? '+' : '' }}{{ formatCurrency(item.gain_or_loss) }}
                          </v-chip>
                        </template>

                        <template v-slot:item.remarks="{ item }">
                          <span class="text-caption">{{ item.remarks || '-' }}</span>
                        </template>

                      </v-data-table>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- No Data Message -->
                <v-row v-if="!loading && reports.length === 0" class="mt-4">
                  <v-col cols="12" class="text-center">
                    <v-icon size="64" color="grey">mdi-delete-clock</v-icon>
                    <p class="text-h6 text-grey mt-2">No disposal records found</p>
                    <p class="text-caption text-grey">Try adjusting the date filters</p>
                  </v-col>
                </v-row>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { prefix } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';

export default {
  components: {},
  data() {
    return {
      itemsPerPage: 10,
      panel: [0],
      expandedPanels: [],
      allExpanded: false,
      search: "",
      detailHeaders: [
        { title: "#SL", align: "center", key: "index", sortable: false, width: "60px"},
        { title: "Asset Code", key: "asset_code", align: "center", sortable: false },
        { title: "Asset Name", key: "asset_name", align: "center", sortable: false },
        { title: "Book Value", key: "book_value", align: "center", sortable: false },
        { title: "Sale Value", key: "sale_value", align: "center", sortable: false },
        { title: "Gain/Loss", key: "gain_or_loss", align: "center", sortable: false },
        { title: "Remarks", key: "remarks", align: "center", sortable: false },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label('From Date'),
        to_date: yup.date().nullable().label('To Date'),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const reports = ref([]);
    const summary = ref({
      total_records: 0,
      total_assets: 0,
      total_book_value: 0,
      total_sale_value: 0,
      total_gain_loss: 0,
    });

    const submit = handleSubmit((values) => {
      loading.value = true;

      // Format dates if they exist
      const params = {
        from_date: formattedDate(from_date.value.value),
        to_date: formattedDate(to_date.value.value),
      };

      Axios.get(`${prefix}assets/reports/disposal-summary`, { params })
        .then((response) => {
          if (response.data.status) {
            reports.value = response.data.data || [];
            
            // Update summary
            if (response.data.summary) {
              summary.value = response.data.summary;
            }
            
            toast.success('Data loaded successfully');
          } else {
            toast.error(response.data.message || 'Failed to load data');
            reports.value = [];
          }
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          reports.value = [];
          console.error('Disposal summary error:', error);
          const errorMsg = error.response?.data?.message || error.message || 'An error occurred while loading data';
          toast.error(errorMsg);
        });
    });

    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-BD', { minimumFractionDigits: 2 });

    return {
      from_date,
      to_date,
      submit,
      errorMessages,
      loading,
      reports,
      summary,
      formatCurrency,
    };
  },
  methods: {
    getDisposalMethodColor(method) {
      const methodMap = {
        'Sale': 'success',
        'Scrap': 'warning',
        'Donation': 'info',
        'Write-off': 'error',
      };
      return methodMap[method] || 'grey';
    },
    expandAll() {
      if (this.allExpanded) {
        this.expandedPanels = [];
      } else {
        this.expandedPanels = this.reports.map((_, index) => index);
      }
      this.allExpanded = !this.allExpanded;
    },
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Disposal Date",
        "Code",
        "Method",
        "Asset Code",
        "Asset Name",
        "Book Value",
        "Sale Value",
        "Gain/Loss",
        "Remarks",
      ];
      const rows = [];
      
      (this.reports || []).forEach((master) => {
        master.details.forEach((detail) => {
          rows.push([
            serialNumber++,
            master.disposal_date,
            master.code || 'N/A',
            master.disposal_method || 'N/A',
            detail.asset_code || 'N/A',
            detail.asset_name,
            this.formatCurrency(detail.book_value),
            this.formatCurrency(detail.sale_value),
            (detail.gain_or_loss >= 0 ? '+' : '') + this.formatCurrency(detail.gain_or_loss),
            detail.remarks || '-',
          ]);
        });
      });

      this.$exportTableToPDF(
        columns,
        rows,
        "Disposal Summary Report",
        "disposal_summary_report_" + this.$fileDate()
      );
    },
    exportToExcel() {
      var data = [[
        "#SL",
        "Disposal Date",
        "Code",
        "Method",
        "Asset Code",
        "Asset Name",
        "Book Value",
        "Sale Value",
        "Gain/Loss",
        "Remarks",
      ]];
      var serialNumber = 1;
      
      (this.reports || []).forEach((master) => {
        master.details.forEach((detail) => {
          data.push([
            serialNumber++,
            master.disposal_date,
            master.code || 'N/A',
            master.disposal_method || 'N/A',
            detail.asset_code || 'N/A',
            detail.asset_name,
            detail.book_value,
            detail.sale_value,
            detail.gain_or_loss,
            detail.remarks || '-',
          ]);
        });
      });

      this.$exportTableToExcel(data, "disposal_summary_report_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[
        "#SL",
        "Disposal Date",
        "Code",
        "Method",
        "Asset Code",
        "Asset Name",
        "Book Value",
        "Sale Value",
        "Gain/Loss",
        "Remarks",
      ]];
      var serialNumber = 1;
      
      (this.reports || []).forEach((master) => {
        master.details.forEach((detail) => {
          data.push([
            serialNumber++,
            master.disposal_date,
            master.code || 'N/A',
            master.disposal_method || 'N/A',
            detail.asset_code || 'N/A',
            detail.asset_name,
            detail.book_value,
            detail.sale_value,
            detail.gain_or_loss,
            detail.remarks || '-',
          ]);
        });
      });

      this.$exportTableToCSV(data, "disposal_summary_report_" + this.$fileDate());
    },
  },
  mounted() {
    // Data will load only when user clicks Search button
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

